<!--头部模块-->

<template>
	<header :class="['c_header', { c_header_white: headerWhite }]">
		<i class="go_back iconfont" v-if="goBack" @click="back">&#xe60c;</i>
		<h1 v-if="headerTitle">{{ headerTitle }}</h1>
		<router-link to="/register" v-if="showRegister" class="register">注册</router-link>
		<router-link to="/search" v-if="showSearch" class="search"><i class="iconfont">&#xe64b;</i></router-link>
		<span class="register">
			<slot name="right"></slot>
		</span>
		<slot name="left"></slot>
	</header>
</template>

<script>
import { getPreviousPage } from '../../js/historyRouter';

export default {
	data() {
		return {};
	},
	props: ['headerTitle', 'goBack', 'showRegister', 'headerWhite', 'showSearch', 'goBackOne'],
	methods: {
		back() {
			let historyAry = getPreviousPage();
			if (!historyAry) {
				window.location.href = '/';
				return;
			}
			if (this.goBackOne) {
				window.location.href = '/';
			} else {
				this.$router.go(-1);
				this.$router.beforeEach((to, from, next) => {
					if (to.path.indexOf('login') > -1 && this.$store.state.userInfo && this.$store.state.userInfo.loginToken) {
						if (to.path.indexOf('goodsdetail') > -1) {
							next();
						}
						if (from.query.goodsId) {
							next({
								path: '/goodsdetail',
								query: { goodsId: from.query.goodsId }
							});
						} else {
							next({ path: '/' });
						}
						if (window.history.length < 1) {
							next({ path: '/' });
						}
					} else {
						next();
					}
				});
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import '../../style/common';

.c_header {
	@include cH(88rem);
	background: linear-gradient(360deg, #51b3ff 0%, #1979f0 100%);
	display: flex;
	padding: 0 px2rem(30rem);
	position: fixed;
	width: 100%;
	top: 0;
	z-index: 10;

	.go_back {
		@include font(50rem, $c_ff);
		position: absolute;
		left: px2rem(30rem);
		top: 0;
	}

	h1 {
		flex: 1;
		line-height: px2rem(90rem);
		text-align: center;
		@include font(34rem, $c_ff);
	}

	.register {
		@include font(30rem, $c_ff);
		position: absolute;
		right: px2rem(30rem);
		top: 0;

		a {
			color: #fff;
		}
	}

	.search {
		@include font(30rem, $c_ff);
		position: absolute;
		right: px2rem(30rem);
		top: 0;

		i {
			@include font(36rem, $c_ff);
		}
	}
}

.c_header_white {
	background: $c_ff;

	.go_back {
		color: $c_black;
	}

	h1 {
		color: $c_black;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue